<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12"> 
        <app-data
          titulo="Información del Comprobante"
          :datos="compraDatos">
        </app-data>

        <!-- <b-card header="Información del Comprobante">
          <b-table 
              small 
              responsive="sm" 
              :items="compraDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card> -->

        <b-card header="Percepciones Provinciales" v-if="compraPercepcionesDatos && compraPercepcionesDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraPercepcionesDatos" 
              :fields="compraPercepcionesFields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Cuentas" v-if="compraCuentasDatos && compraCuentasDatos.length != 0" >
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraCuentasDatos" 
              :fields="compraCuentasFields">
            <template v-slot:cell(montoBase)="data">
              {{ data.item.montoBase | moneda }}
            </template>
            <template v-slot:cell(montoImpuestos)="data">
              {{ data.item.montoImpuestos | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Renglones" v-if="compraRenglonesDatos && compraRenglonesDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraRenglonesDatos" 
              :fields="compraRenglonesFields">
            <template v-slot:cell(importeOrden)="data">
              {{ data.item.importeOrden | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Remitos" v-if="compraRemitosDatos && compraRemitosDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraRemitosDatos" 
              :fields="compraRemitosFields">
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Comprobante de Viaticos" v-if="compraViaticoDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraViaticoDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Amortización de Gastos" v-if="compraAmortizacionDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraAmortizacionDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Comisiones" v-if="accesoComisiones && compraPresupuestosComisionesDatos && compraPresupuestosComisionesDatos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraPresupuestosComisionesDatos" 
              :fields="compraComisionesFields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compras/getField',
  mutationType: 'compras/updateField',
});

export default {
  name: 'CompraData',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    routedFrom: {
      type: String,
      default: 'Compras'
    }
  },
  data: () => {
    return {
      compraId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      compraCuentasFields: [
        { 
          key: 'codigoCuenta',
          label: 'Código'
        },
        { key: 'cuenta' },
        { 
          key: 'montoBase',
          class: 'text-right' 
        },
        { 
          key: 'montoImpuestos',
          class: 'text-right' 
        },
      ],
      
      compraRenglonesFields: [
        { 
          key: 'ordenProveedorId',
          label: 'Nro.Orden'
        },
        { key: 'ordenProveedor' },
        { 
          key: 'importeOrden',
          label: 'Total Orden',
          class: 'text-right' 
        },
        { 
          key: 'importe',
          label: 'Importe Facturado',
          class: 'text-right' 
        },
      ],

      compraPercepcionesFields: [
        { key: 'jurisdiccion' },
        { 
          key: 'importe',
          class: 'text-right' 
        },
      ],

      compraRemitosFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        { key: 'comprobante' },
        { key: 'remitoDestino' },
        { 
          key: 'importe', 
          class: "text-right" 
        }
      ],

      compraComisionesFields: [
        { 
          key: 'presupuestoNumero',
          label: 'Nro.Presupuesto'
        },
        { 
          key: 'presupuestoInterno',
          label: 'Presupuesto'
        },
        { 
          key: 'importe',
          label: 'Importe Facturado',
          class: 'text-right' 
        },
      ],

      accesoComisiones: false
    }
  },
  created() {
    this.compraId = this.$route.params.id;

    this.$store.dispatch('compras/getDatos', this.compraId)
      .catch(error => this.showErrorMsj(error));

    let userRolId = parseInt(this.$store.getters['user/rolId']);
    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
      case 21: /* Responsable de Finanzas y Proveedores */
        this.accesoComisiones = true;
        break;
    }
  },  
  computed: {
    ...mapFields([
      'compraDatos',
      'compraCuentasDatos',
      'compraRenglonesDatos',
      'compraRemitosDatos',
      'compraPercepcionesDatos',
      'compraViaticoDatos',
      'compraAmortizacionDatos',
      'compraPresupuestosComisionesDatos'
    ]),
  },
  methods: {
    goBack() {
      if (this.routedFrom == 'ResumenGastos') {
        this.$router.push({ name: 'ResumenGastos', params: { inicializar: false } }); 
      } else {
        this.$router.push({ name: this.routedFrom }); 
      }      
    },
  }
}
</script>
